<template>
    <div>
        {{ $t('notification.driveFolderCreated', { 
            actor: $_.get(activity, 'actorUser.name'), 
            folderName: $_.get(activity, 'payload.folderName')
        }) }}
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "DriveFolderCreated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

